import React from 'react';
import { observer } from 'mobx-react';
import './styles.css';
import LoadingProgressStore from '../../store/LoadingProgressStore';

export const LoadingProgress = observer(({}) => {
  return (
    <>
      <div className={LoadingProgressStore.isLoading ? 'loading-state' : 'loading-state lm-d-none'}>
        <div className="loading"></div>
      </div>
    </>
  );
});
